import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import '../styles/my-registrations.css';
import '../styles/certificates.css';

export default function CertificateVerificationPage() {
  const { publicId } = useParams();
  const [status, setStatus] = useState('loading');
  const [certificate, setCertificate] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/volunteer-certificates/verify/${encodeURIComponent(publicId || '')}`)
      .then(({ data }) => { setCertificate(data.certificate); setStatus('ready'); })
      .catch((error) => { setMessage(error.response?.data?.message || 'Unable to verify this certificate.'); setStatus('error'); });
  }, [publicId]);

  return <section className="certificate-verification-page">
    <div className="certificate-verification-mark">UC CERTIFICATE VERIFICATION</div>
    {status === 'loading' && <article className="certificate-verification-card">Verifying certificate…</article>}
    {status === 'error' && <article className="certificate-verification-card invalid"><h1>Certificate not verified</h1><p>{message}</p></article>}
    {status === 'ready' && <article className={`certificate-verification-card ${certificate.status}`}>
      <span className="certificate-status">{certificate.status === 'issued' ? 'Verified certificate' : `Certificate ${certificate.status}`}</span>
      <h1>{certificate.recipientName}</h1>
      <p className="certificate-type">{certificate.certificateType}</p>
      <dl>
        <div><dt>Event</dt><dd>{certificate.eventName}</dd></div>
        <div><dt>Service date</dt><dd>{certificate.serviceDate}</dd></div>
        <div><dt>Approved hours</dt><dd>{certificate.approvedHours}</dd></div>
        <div><dt>Issue date</dt><dd>{certificate.issueDate}</dd></div>
        <div><dt>Certificate number</dt><dd>{certificate.certificateNumber}</dd></div>
        <div><dt>Status</dt><dd>{certificate.status}</dd></div>
      </dl>
      <p className="certificate-verification-note">Udyog Connect verifies only the public certificate information shown above. No contact or account information is displayed.</p>
    </article>}
  </section>;
}
